import Vue from 'vue'
import ZendeskPlugin from './plugin'
// инициализация zendesk
Vue.use(ZendeskPlugin, {
  key: process.env.VUE_APP_ZENDESK_KEY,
  disabled: true,
  hideOnLoad: false,
  logger: false,
  settings: {
    webWidget: {
      color: {
        theme: '#ff2f00'
      },
      chat: {
        concierge: {
          name: window.location.pathname.includes('/uk/') ? 'Ваш помічник' : 'Centrum pomocy',
          title: {
            '*': 'Skontaktuj się z nami',
            uk: 'Майстер з обслуговування'
          }
        },
        offlineForm: {
          greeting: {
            '*': 'Jesteśmy dostępni online od poniedziałku do soboty w godzinach 08:00-18:00',
            uk: 'Ми онлайн з понеділка по суботу 08:00-18:00'
          }
        },
        departments: {
          enabled: ['Centrum Pomocy Dnipro-M Poland'],
          select: 'Centrum Pomocy Dnipro-M Poland'
        }
      }
    }
  }
})
